import React from "react";
import ReactDOM from "react-dom/client";
// Initialize Firebase app once for the whole app
import "./firebase";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
